/* let videoBtn = document.querySelector('.video-btn') */
let videoModal = document.getElementById('video_modal')
/* let videoSrc = videoBtn.dataset.video;  */
let video = document.getElementById('video-embed')

/* if (videoSrc.includes('youtube')) {
	videoModal.addEventListener('shown.bs.modal',(e)=>{
		video.setAttribute('src', videoSrc + '?autoplay=1&amp;modestbranding=1&amp;showinfo=0')
  	})
} else {
} */

if(document.getElementById('video_modal')){

	videoModal.addEventListener('shown.bs.modal',(e)=>{
		video.play();
	})

	videoModal.addEventListener('hide.bs.modal',(e)=>{
		video.pause();
		video.currentTime = 0;
	})

}